(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/flows/create-fundraising-team/views/success', '<div class="create-flow extra-padding">\n' + '  <i\n' + '    class="fa fa-check-circle-o create-flow_success-icon"\n' + '    data-ng-style="{ color: ui.primaryColor }"\n' + '  ></i>\n' + '  <h2 class="create-flow_success-title">Team Created</h2>\n' + '  <p class="create-flow_success-message">Nice work! Way to go.</p>\n' + '</div>\n' + '');
}]);
})();